import { PaymentMethodEnum } from "../models/types.mjs";
import { extractPaymentMethodInputSnapshot } from "./snapshot.mjs";
import { paymentMethodIndividualFromSnapshot } from "./individual.mjs";
import { paymentMethodSponsoredFromSnapshot } from "./sponsored.mjs";
import { DateTime } from "luxon";

// src/paymentMethod/utils.ts
function paymentMethodFromSnapshot(snapshot, now = DateTime.now()) {
	switch (snapshot.paymentMethodKind) {
		case "sponsored": return paymentMethodSponsoredFromSnapshot(snapshot, now);
		case "default":
		default: return paymentMethodIndividualFromSnapshot(snapshot, now);
	}
}
const paymentMethodForCustomer = (customer, trialInfo, subscription, referralProgram, sponsorInfo, product, subscriptionSchedule) => {
	const kind = referralProgram?.paymentMethod ?? "default";
	return paymentMethodFromSnapshot(extractPaymentMethodInputSnapshot({
		paymentMethodKind: kind,
		signupPaymentInfo: customer.signupPaymentInfo,
		signupFlowCompleted: customer.signupFlowCompleted ?? false,
		trialInfo,
		subscription,
		sponsorInfo,
		product,
		subscriptionSchedule
	}));
};
/** True when the customer has active paid/sponsored access (same rules as app payment UI). */
const isCustomerSubscriptionActive = (customer, trialInfo, subscription, referralProgram, sponsorInfo, product) => paymentMethodForCustomer(customer, trialInfo, subscription, referralProgram, sponsorInfo, product).subscriptionActive;

export { extractPaymentMethodInputSnapshot, isCustomerSubscriptionActive, paymentMethodForCustomer, paymentMethodFromSnapshot };
//# sourceMappingURL=utils.mjs.map